// Lightweight, dependency-free flash toast — matches the session-expiry flash in AuthContext.jsx.
export function showFlash(text, { color = "linear-gradient(120deg,#8b5cf6,#38bdf8)" } = {}) {
  if (typeof document === "undefined") return;
  const flash = document.createElement("div");
  flash.textContent = text;
  Object.assign(flash.style, {
    position: "fixed", top: "18px", left: "50%", transform: "translateX(-50%)",
    background: color, color: "#fff",
    fontFamily: "Inter, system-ui, sans-serif", fontSize: "13px", fontWeight: "600",
    padding: "10px 18px", borderRadius: "999px", zIndex: "999999",
    boxShadow: "0 10px 24px rgba(15,23,42,0.25)", maxWidth: "min(90vw, 420px)", textAlign: "center",
  });
  document.body.appendChild(flash);
  setTimeout(() => flash.remove(), 4000);
}
